import React from "react";
import PageWrapper from "./common.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import LateCancelNoShowTable from "components/report/LateCancelNoShowTable";

const LateCancelNoShowReport = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.report"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.late_cancel_no_show_report"
          }
        ]}
      />
      <div className="user-tbl">
        <LateCancelNoShowTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.auth
  };
};

export default connect(mapStateToProps, null)(LateCancelNoShowReport);
